import React, { useEffect } from 'react';
import Toolbar from 'src/components/Toolbar';
import { useTranslation } from 'react-i18next';
import Button from 'src/components/Button';
import { useHistory } from 'react-router-dom';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import './style.scoped.css';
import iconShieldCheck from 'src/assets/shield_check_outline.svg';
import iconDollar from 'src/assets/dollar.svg';
import iconReload from 'src/assets/reload.svg';
import iconCard from 'src/assets/credit_card_blue.svg';
import { confirmQuitFlow } from 'src/utils';
import { createOrder } from 'src/api';
import LoadingService from 'src/utils/LoadingService';
import PopupService from 'src/utils/PopupService';
import homeStore, { HomeStore } from 'src/stores/HomeStore';
import { observer } from 'mobx-react-lite';
dayjs.extend(customParseFormat);

interface SpaInsurranceInfoObserverProps {
  store?: HomeStore;
}

const SpaInsurranceInfoObserver = observer(
  ({ store }: SpaInsurranceInfoObserverProps) => {
    const { t } = useTranslation();
    const history = useHistory();

    useEffect(() => {
      homeStore.fetchOnlineProductHome();
    }, []);

    const _handleBuyInsurrance = async () => {
      console.log('_handleBuyInsurrance Spa');
      // history.push('/your_info_spa');
      try {
        LoadingService.instance.current.open();
        const createOrderRes = await createOrder(1000000, 'Mua bảo hiểm SPA');
        LoadingService.instance.current.close();
        console.log('createOrderRes', createOrderRes?.data, {
          type: 'PAYMENT_HUB_TRANSACTION',
          data: createOrderRes?.data,
        });

        if (window?.ReactNativeWebView) {
          window?.ReactNativeWebView?.postMessage(
            JSON.stringify({
              type: 'PAYMENT_HUB_TRANSACTION',
              data: createOrderRes?.data,
            })
          );
        }
      } catch (err) {
        LoadingService.instance.current.close();
        PopupService.instance.current.open({
          visible: true,
          title: t('notification'),
          content: err?.response?.data?.error_message,
          okTitle: t('close'),
          onOk: () => {
            PopupService.instance.current.close();
          },
        });
      }
    };

    const _renderFeeInfo = () => {
      return (
        <div className={'infoCard'}>
          <div className={'cardHeader largeTitleText text-primary'}>
            {store?.spaOnlineProduct?.name}
          </div>
          <div className="cardRowBorder">
            <div className="iconContainer">
              <img src={iconDollar} />
            </div>
            <div className="flex flex-col">
              <div className={'smallTitle2 rowTitle'}>
                {t('insurrance_amount')}
              </div>
              <div className="blockTitlePrimary">300.000.000 VNĐ</div>
            </div>
          </div>
          <div className="cardRowBorder">
            <div className="iconContainer">
              <img src={iconReload} />
            </div>
            <div className="flex flex-col">
              <div className={'smallTitle2 rowTitle flex'}>
                {t('pay_method_and_term')}
              </div>
              <div className="bodyText2 text-onSurface flex">
                {t('method_auto_debit')}
              </div>
            </div>
          </div>
          <div className="cardRowNoBorder">
            <div className="iconContainer">
              <img src={iconCard} />
            </div>
            <div className="flex flex-col">
              <div className={'smallTitle2 rowTitle'}>
                {t('insurrance_fee')}
              </div>
              <div>
                <div className="bodyText2">
                  <span className="smallTitle2Primary">65.000 VNĐ/tháng</span>{' '}
                  cho Nữ
                </div>
                <div className="bodyText2">
                  <span className="smallTitle2Primary">95.000 VNĐ/tháng</span>{' '}
                  cho Name
                </div>
                <div className="bodyText2">
                  (Miễn phí kỳ đầu đối với một số Khách hàng may mắn)
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    };

    const _renderBenefitInfo = () => {
      return (
        <div className={'infoCard'}>
          <div className={'cardHeader flex flex-row items-center'}>
            <div className="iconContainer">
              <img src={iconShieldCheck} />
            </div>
            <div className={'smallTitle2'}>{t('insurance_benefit')}</div>
          </div>
          <div className="py-6">
            <div className="cardContentRow">
              <div className="dot" />
              <div className="bodyText2">
                Chi trả lên đến{' '}
                <span className="smallTitle2Primary">300.000.000 VNĐ</span>{' '}
                trong trường hợp NĐBH Tử vong hoặc bị Thương tật (toàn bộ hoặc
                bộ phận) vĩnh viễn do tai nạn.
              </div>
            </div>
            <div className="cardContentRow">
              <div className="dot" />
              <div className="bodyText2">
                Chi trả lên đến{' '}
                <span className="smallTitle2Primary">300.000.000 VNĐ</span>{' '}
                trong trường hợp NĐBH Tử vong hoặc bị Thương tật (toàn bộ hoặc
                bộ phận) vĩnh viễn do tai nạn.
              </div>
            </div>
            <div className="cardContentRow">
              <div className="dot" />
              <div className="bodyText2">
                Quyền lợi Tử vong hoặc Thương tật vĩnh viễn do Tai nạn được{' '}
                <span className="smallTitle2Primary">nhân đôi</span> nếu Tai nạn
                xảy ra ở nước ngoài hoặc trên các chuyến bay thương mại.
              </div>
            </div>
            <div className="cardContentRowLast">
              <div className="dot" />
              <div className="bodyText2">
                Chi trả <span className="smallTitle2Primary">600.000 VNĐ</span>
                /ngày nếu Người được bảo hiểm phải nhập viện nội trú do tai nạn
                từ 2 ngày trở lên.
              </div>
            </div>
          </div>
        </div>
      );
    };

    const _handleClose = () => {
      console.log('Handle close');
      confirmQuitFlow(history);
    };

    return (
      <div className="screen-container bg-background">
        <Toolbar
          title={t('buy_insurrance')}
          showClose={true}
          onClose={_handleClose}
        />
        <div className="max-w-md mx-auto screenScrollContainer">
          <div>
            <img
              src={homeStore?.spaOnlineProduct?.photoDetail}
              className={'insurranceImage'}
            />
          </div>
          <div className="overlapContent">
            {_renderFeeInfo()}
            {_renderBenefitInfo()}
          </div>
        </div>
        <div className="bottomButtonBlock">
          <Button
            text={t('continue')}
            onClick={_handleBuyInsurrance}
            extraClassName={'w-full'}
          />
        </div>
      </div>
    );
  }
);

const SpaInsurranceInfo = () => <SpaInsurranceInfoObserver store={homeStore} />;
export default SpaInsurranceInfo;
